import React from 'react';

import {
  add_to_favourites,
  localstorageAvailable,
  parseDate2Unix,
  remove_from_favourites
} from '../../../services/services';

import { T } from '../../../../../common/locale/translate';
import { trackAnalyticsEvent } from '../../../services/analytics';

export default class Favourites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        pristine: { icon: 'fa-heart-o', title: T('add_to_favourites') },
        added: { icon: 'fa-heart', title: T('added_to_favourites') },
        error: { icon: 'fa-heart-o', title: T('favourites_error') },
        warning: { icon: 'fa-heart-o', title: T('favourites_warning') }
      },
      currentStatus: 'pristine',
      item_id: false,
      fav_uuid: false,
      offer_composite_key: false,
      availableLocalstorage: true
    };
  }

  componentDidMount() {
    const availableLocalstorage = localstorageAvailable();
    let { fav_uuid, item_id, offer_composite_key } = this.state;
    if (availableLocalstorage) {
      const saved_offer = this.searchFavouriteOffer();
      fav_uuid = saved_offer.fav_uuid;
      item_id = saved_offer.item_id;
      offer_composite_key = saved_offer.offer_composite_key;
    }
    this.setState({
      availableLocalstorage,
      fav_uuid,
      item_id,
      offer_composite_key,
      currentStatus: item_id ? 'added' : 'pristine'
    });
  }

  render() {
    const status = this.state.currentStatus;
    const { icon, title } = this.state.options[status];
    return (
      <div
        className={`add-to-cubboard ${this.state.currentStatus}`}
        onClick={this.handleClick}
        title={title}
      >
        <i className={`fa ${icon}`} />
      </div>
    );
  }

  handleClick = e => {
    e.stopPropagation();
    if (this.state.availableLocalstorage) {
      this.state.item_id ? this.removeFromFavourites() : this.add2Favourites();
    }
  };

  favouritesParams(data) {
    return {
      name: data.subject ? data.subject.name : '',
      region_id: data.subject ? data.subject.region_id : '',
      country_name: data.subject ? data.subject.country_name : '',
      city: data.subject ? data.subject.city : '',
      offer_id: data.id ? data.id : '',
      subject_id: data.subject ? data.subject.id : '',
      offer_type: data.offer_type,
      person_price: data.price_pln ? data.price_pln : '',
      adults: data.adults_number ? data.adults_number : '',
      children_ages: data.children_ages ? data.children_ages.join(',') : '',
      departure_date: data.departure_date
        ? parseDate2Unix(data.departure_date)
        : '',
      return_date: data.return_date ? parseDate2Unix(data.return_date) : '',
      parser: data.subject ? data.subject.parser : '',
      accommodation: data.accommodation
        ? data.accommodation.polish_name
          ? data.accommodation.polish_name
          : data.accommodation.name
        : '',
      alimentation: data.boards
        ? data.boards.length
          ? data.boards[0].name
          : ''
        : '',
      operator_code: data.operator ? data.operator.code : ''
    };
  }

  createCompositeKey() {
    const offer = this.props.offer;
    const key = {
      offer_id: offer.id ? offer.id : '',
      id: offer.subject ? (offer.subject.id ? offer.subject.id : '') : '',
      adults_number: offer.adults_number ? offer.adults_number : '',
      children_ages: offer.children_ages
        ? offer.children_ages.length
          ? offer.children_ages.join(',')
          : ''
        : '',
      departure_date: offer.deprature_date ? offer.deprature_date : '',
      return_date: offer.return_date ? offer.return_date : ''
    };
    return `${key.offer_id}${key.id}${key.adults_number}${key.children_ages}${
      key.departure_date
    }${key.return_date}`;
  }

  trigerHashChange() {
    const hash = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');
    window.location.hash = `${hash}.`;
  }

  initializeFavourites(fav_uuid, id, offer) {
    if (this.state.availableLocalstorage) {
      const favourites = [{ key: this.state.offer_composite_key, id, offer }];
      localStorage.setItem('fav_uuid', fav_uuid);
      localStorage.setItem(
        `favourites_${fav_uuid}`,
        JSON.stringify({ favourites })
      );
      localStorage.setItem('fav_counter', 1);
      this.trigerHashChange();
    }
  }

  searchFavouriteOffer() {
    let fav_uuid = localStorage.getItem('fav_uuid') || false,
      favourites = localStorage.getItem(`favourites_${fav_uuid}`) || false,
      offer_composite_key = this.createCompositeKey(),
      item_id = false;
    if (fav_uuid && favourites) {
      JSON.parse(favourites).favourites.map(favourite => {
        if (favourite.key === offer_composite_key) {
          item_id = favourite.id;
        }
      });
    }

    return {
      fav_uuid,
      item_id,
      offer_composite_key
    };
  }

  add2Favourites() {
    const data = this.favouritesParams(this.props.offer);
    let fav_uuid = localStorage.getItem('fav_uuid');
    this.setState({ currentStatus: 'added' });
    trackAnalyticsEvent(
      'schowek',
      'dodanie do schowka',
      'dodanie ze strony oferty'
    );
    add_to_favourites(fav_uuid, data, this.props.token)
      .then(response => {
        let item_id = response.data.favourites_item.id;
        if (!fav_uuid) {
          this.initializeFavourites(
            response.data.favourites.uuid,
            item_id,
            this.props.offer
          );
        } else {
          const offer = {
            key: this.state.offer_composite_key,
            id: item_id,
            offer: this.props.offer
          };
          let offers_list = JSON.parse(
            localStorage.getItem(`favourites_${fav_uuid}`)
          );
          let counter = parseInt(localStorage.getItem('fav_counter'));
          offers_list.favourites.push(offer);
          localStorage.setItem(
            `favourites_${fav_uuid}`,
            JSON.stringify(offers_list)
          );
          localStorage.setItem('fav_counter', ++counter);
          this.trigerHashChange();
        }
        this.setState({ fav_uuid, item_id });
      })
      .catch(() => {
        this.setState({ currentStatus: 'error' });
      });
  }

  removeFromFavourites() {
    const data = { fav_item: { id: this.state.item_id } };
    remove_from_favourites(this.state.fav_uuid, data, this.props.token)
      .then(() => {
        let fav_uuid = localStorage.getItem('fav_uuid'),
          favourites = localStorage.getItem(`favourites_${fav_uuid}`),
          counter = parseInt(localStorage.getItem('fav_counter'));
        favourites = JSON.parse(favourites).favourites.filter(
          v => v.id !== this.state.item_id
        );
        localStorage.setItem(
          `favourites_${fav_uuid}`,
          JSON.stringify({ favourites })
        );
        localStorage.setItem('fav_counter', --counter);
        this.trigerHashChange();
        this.setState({ item_id: false, currentStatus: 'pristine' });
      })
      .catch(() => {
        this.setState({ currentStatus: 'error' });
      });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/favourites.jsx